import ConfirmationFooter from './ConfirmationFooter'

export default ConfirmationFooter
